export const TAGS_ALL = 'TAGS_ALL';
export const TAGS_ALL_SUCCESS = 'TAGS_ALL_SUCCESS';
export const TAGS_GET = 'TAGS_GET';
export const TAGS_GET_SUCCESS = 'TAGS_GET_SUCCESS';
export const TAGS_CREATE = 'TAGS_CREATE';
export const TAGS_CREATE_SUCCESS = 'TAGS_CREATE_SUCCESS';
export const TAGS_UPDATE = 'TAGS_UPDATE';
export const TAGS_UPDATE_SUCCESS = 'TAGS_UPDATE_SUCCESS';
export const TAGS_DELETE = 'TAGS_DELETE';
export const TAGS_DELETE_SUCCESS = 'TAGS_DELETE_SUCCESS';